/**
 * @see https://vuejs.org/guide/extras/web-components#building-custom-elements-with-vue
 * @see https://developer.mozilla.org/de/docs/Web/API/CustomElementRegistry/define
 */

import { defineCustomElement } from 'vue'

import NewsComponentItemCloseButton from './components/NewsComponentItemCloseButton.ce.vue'
if (!customElements.get('news-component-item-close-button')) {
    customElements.define('news-component-item-close-button', defineCustomElement(NewsComponentItemCloseButton))
}

import NewsComponentItemLinkButton from './components/NewsComponentItemLinkButton.ce.vue'
if (!customElements.get('news-component-item-link-button')) {
    customElements.define('news-component-item-link-button', defineCustomElement(NewsComponentItemLinkButton))
}

import NewsComponentItem from './components/NewsComponentItem.ce.vue'
if (!customElements.get('news-component-item')) {
    customElements.define('news-component-item', defineCustomElement(NewsComponentItem))
}

import NewsComponentViewer from './components/NewsComponentViewer.ce.vue'
if (!customElements.get('news-component-viewer')) {
    customElements.define('news-component-viewer', defineCustomElement(NewsComponentViewer))
}

declare module 'vue' {
    interface GlobalComponents {
        'news-component-item-close-button': typeof NewsComponentItemCloseButton,
        'news-component-item-link-button': typeof NewsComponentItemLinkButton,
        'news-component-item': typeof NewsComponentItem,
        'news-component-viewer': typeof NewsComponentViewer
    }
}